// GENERATED by scripts/gen-hooks.mjs. Do not edit by hand.
// 32 hooks for backend/marketing.

import { useBackend } from '../useBackend'

/** POST /api/marketing/acceptContentPlanFlag */
export function useAcceptContentPlanFlag<T = any>() {
  return useBackend<T>('marketing/acceptContentPlanFlag')
}

/** POST /api/marketing/archiveContentItem */
export function useArchiveContentItem<T = any>() {
  return useBackend<T>('marketing/archiveContentItem')
}

/** POST /api/marketing/attachDesignAsset */
export function useAttachDesignAsset<T = any>() {
  return useBackend<T>('marketing/attachDesignAsset')
}

/** POST /api/marketing/commitContentPlanImport */
export function useCommitContentPlanImport<T = any>() {
  return useBackend<T>('marketing/commitContentPlanImport')
}

/** POST /api/marketing/createContentItem */
export function useCreateContentItem<T = any>() {
  return useBackend<T>('marketing/createContentItem')
}

/** POST /api/marketing/createDesignRequest */
export function useCreateDesignRequest<T = any>() {
  return useBackend<T>('marketing/createDesignRequest')
}

/** POST /api/marketing/decideContentItem */
export function useDecideContentItem<T = any>() {
  return useBackend<T>('marketing/decideContentItem')
}

/** POST /api/marketing/discardContentPlanImport */
export function useDiscardContentPlanImport<T = any>() {
  return useBackend<T>('marketing/discardContentPlanImport')
}

/** POST /api/marketing/getContentAssetUrl */
export function useGetContentAssetUrl<T = any>() {
  return useBackend<T>('marketing/getContentAssetUrl')
}

/** POST /api/marketing/getContentBoard */
export function useGetContentBoard<T = any>() {
  return useBackend<T>('marketing/getContentBoard')
}

/** POST /api/marketing/getContentCalendar */
export function useGetContentCalendar<T = any>() {
  return useBackend<T>('marketing/getContentCalendar')
}

/** POST /api/marketing/getContentItem */
export function useGetContentItem<T = any>() {
  return useBackend<T>('marketing/getContentItem')
}

/** POST /api/marketing/getContentPlanFileUrl */
export function useGetContentPlanFileUrl<T = any>() {
  return useBackend<T>('marketing/getContentPlanFileUrl')
}

/** POST /api/marketing/getContentPlanImport */
export function useGetContentPlanImport<T = any>() {
  return useBackend<T>('marketing/getContentPlanImport')
}

/** POST /api/marketing/getContentPlanImports */
export function useGetContentPlanImports<T = any>() {
  return useBackend<T>('marketing/getContentPlanImports')
}

/** POST /api/marketing/getDesignRequests */
export function useGetDesignRequests<T = any>() {
  return useBackend<T>('marketing/getDesignRequests')
}

/** POST /api/marketing/getMarketingRefs */
export function useGetMarketingRefs<T = any>() {
  return useBackend<T>('marketing/getMarketingRefs')
}

/** POST /api/marketing/publishContentItem */
export function usePublishContentItem<T = any>() {
  return useBackend<T>('marketing/publishContentItem')
}

/** POST /api/marketing/recordContentAsset */
export function useRecordContentAsset<T = any>() {
  return useBackend<T>('marketing/recordContentAsset')
}

/** POST /api/marketing/removeContentAsset */
export function useRemoveContentAsset<T = any>() {
  return useBackend<T>('marketing/removeContentAsset')
}

/** POST /api/marketing/removeContentCaption */
export function useRemoveContentCaption<T = any>() {
  return useBackend<T>('marketing/removeContentCaption')
}

/** POST /api/marketing/saveContentCaption */
export function useSaveContentCaption<T = any>() {
  return useBackend<T>('marketing/saveContentCaption')
}

/** POST /api/marketing/saveContentPlanRow */
export function useSaveContentPlanRow<T = any>() {
  return useBackend<T>('marketing/saveContentPlanRow')
}

/** POST /api/marketing/saveMarketingPlan */
export function useSaveMarketingPlan<T = any>() {
  return useBackend<T>('marketing/saveMarketingPlan')
}

/** POST /api/marketing/scheduleContentPlanImport */
export function useScheduleContentPlanImport<T = any>() {
  return useBackend<T>('marketing/scheduleContentPlanImport')
}

/** POST /api/marketing/selectContentCaption */
export function useSelectContentCaption<T = any>() {
  return useBackend<T>('marketing/selectContentCaption')
}

/** POST /api/marketing/setContentPlanImport */
export function useSetContentPlanImport<T = any>() {
  return useBackend<T>('marketing/setContentPlanImport')
}

/** POST /api/marketing/signContentUpload */
export function useSignContentUpload<T = any>() {
  return useBackend<T>('marketing/signContentUpload')
}

/** POST /api/marketing/submitContentItem */
export function useSubmitContentItem<T = any>() {
  return useBackend<T>('marketing/submitContentItem')
}

/** POST /api/marketing/updateContentItem */
export function useUpdateContentItem<T = any>() {
  return useBackend<T>('marketing/updateContentItem')
}

/** POST /api/marketing/updateDesignRequest */
export function useUpdateDesignRequest<T = any>() {
  return useBackend<T>('marketing/updateDesignRequest')
}

/** POST /api/marketing/uploadContentPlan */
export function useUploadContentPlan<T = any>() {
  return useBackend<T>('marketing/uploadContentPlan')
}
